import { styled } from '@mui/material';
import { GivelifyLink } from '../link';
import { GivelifyModal } from '../modal';
import { DesignTokens } from '../specify';

export const FlowContainer = styled(GivelifyModal)(({ theme }) => ({
    '& .MuiPaper-root': {
        margin: '0',
        padding: '0',
    },
}));

export const FlowHeaderWrapper = styled('div')(({ theme }) => ({
    padding: '20px 32px',
    borderBottom: `1px solid ${DesignTokens.color.dividerPrimaryDark}`,

    [theme.breakpoints.down('smallTablet')]: {
        padding: '20px 16px',
    },

    '& .heading': {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('smallTablet')]: {
            fontSize: '14px',
        },
        [theme.breakpoints.down('mobile')]: {
            fontSize: '14px',
            fontWeight: 800,
            marginLeft: '12px',
        },
    },
    '& .lock-icon': {
        marginLeft: theme.spacing(4),
        color: DesignTokens.color.neutralGrey,
        fontSize: '18px',
        [theme.breakpoints.down('mobile')]: {
            fontSize: '16px',
            marginLeft: theme.spacing(3),
        },
    },
    '& .lock-text': {
        marginLeft: theme.spacing(0.5),
        color: DesignTokens.color.neutralGrey,
        fontSize: '16px',
        [theme.breakpoints.down('mobile')]: {
            fontSize: '12px',
            width: '110px',
        },
    },
}));

export const FlowHelpWrapper = styled('div')(({ theme }) => ({
    marginTop: '40px',
    padding: '24px 16px',
    borderRadius: '8px',
    border: `1px solid ${DesignTokens.color.neutralPlatinum}`,
    borderTop: `8px solid ${DesignTokens.color.borderComponentPrimaryAccent}`,
    maxHeight: '540px',
    maxWidth: '400px',
}));

export const FlowContentWrapper = styled('div')(({ theme }) => ({
    padding: '24px 76px',
    display: 'grid',
    gridTemplateColumns: '9fr 1fr 344px',
    maxWidth: '1199px',

    [theme.breakpoints.down('smallTablet')]: {
        padding: '24px 16px',
        gridTemplateColumns: '1fr',
    },

    '& .main-content': {
        gap: '64px',
        [theme.breakpoints.down('mobile')]: {
            paddingRight: 0,
        },
    },

    '& .help-content': {
        gridColumn: 3,
    },
}));

export const FlowActionsContainer = styled('div')(({ theme }) => ({
    width: '100%',
    display: 'flex',
    [theme.breakpoints.down('smallTablet')]: {
        '& .double': {
            flexDirection: 'column-reverse',
        },

        '& .main': {
            flexDirection: 'column-reverse',
        },

        '& .back': {
            marginTop: '16px',
        },

        '& button': {
            fontSize: '16px',
        },
    },
}));

export const CustomContentContainer = styled('div')(({ theme }) => ({
    padding: '24px 76px 0 76px',
    [theme.breakpoints.down('smallTablet')]: {
        padding: '24px 16px 0 16px',
    },

    '& .notification': {
        marginTop: '32px',
        maxWidth: 'calc(1199px - 152px)',
    },
}));

export const StyledLink = styled(GivelifyLink)({
    fontWeight: 600,
    color: DesignTokens.color.textErrorDefault,
})